import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["backdrop", "layoutSection"];

  open() {
    this.backdropTarget.classList.remove("hidden");
    document.body.style.overflow = "hidden";
  }

  close() {
    this.backdropTarget.classList.add("hidden");
    document.body.style.overflow = "";
  }

  toggleLayout(event) {
    const showLayout = event.target.value === "all";
    this.layoutSectionTarget.classList.toggle("hidden", !showLayout);
  }
}
